module.exports = {
	"v": "4.8.0",
	"meta": {
		"g": "LottieFiles AE 3.4.5",
		"a": "",
		"k": "",
		"d": "",
		"tc": ""
	},
	"fr": 30,
	"ip": 0,
	"op": 81,
	"w": 400,
	"h": 480,
	"nm": "01 Cube Dance B",
	"ddd": 0,
	"assets": [
		{
			"id": "image_0",
			"w": 400,
			"h": 480,
			"u": "",
			"p": "data:image/png;base64,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",
			"e": 1
		}
	],
	"layers": [
		{
			"ddd": 0,
			"ind": 1,
			"ty": 3,
			"nm": "Null 1",
			"sr": 1,
			"ks": {
				"o": {
					"a": 0,
					"k": 0,
					"ix": 11
				},
				"r": {
					"a": 0,
					"k": 0,
					"ix": 10
				},
				"p": {
					"a": 0,
					"k": [
						312,
						304,
						0
					],
					"ix": 2
				},
				"a": {
					"a": 0,
					"k": [
						0,
						0,
						0
					],
					"ix": 1
				},
				"s": {
					"a": 0,
					"k": [
						100,
						100,
						100
					],
					"ix": 6
				}
			},
			"ao": 0,
			"ip": 0,
			"op": 2700,
			"st": 0,
			"bm": 0
		},
		{
			"ddd": 0,
			"ind": 2,
			"ty": 2,
			"nm": "4",
			"refId": "image_0",
			"sr": 1,
			"ks": {
				"o": {
					"a": 0,
					"k": 100,
					"ix": 11
				},
				"r": {
					"a": 0,
					"k": 0,
					"ix": 10
				},
				"p": {
					"a": 1,
					"k": [
						{
							"i": {
								"x": 0.833,
								"y": 0.833
							},
							"o": {
								"x": 0.8,
								"y": 0
							},
							"t": 0,
							"s": [
								199,
								240,
								0
							],
							"to": [
								0,
								0,
								0
							],
							"ti": [
								0,
								0,
								0
							]
						},
						{
							"i": {
								"x": 0.833,
								"y": 0.833
							},
							"o": {
								"x": 0.167,
								"y": 0.167
							},
							"t": 10,
							"s": [
								199,
								283,
								0
							],
							"to": [
								0,
								0,
								0
							],
							"ti": [
								0,
								0,
								0
							]
						},
						{
							"i": {
								"x": 0.833,
								"y": 0.833
							},
							"o": {
								"x": 0.167,
								"y": 0.167
							},
							"t": 30,
							"s": [
								199,
								283,
								0
							],
							"to": [
								0,
								0,
								0
							],
							"ti": [
								0,
								0,
								0
							]
						},
						{
							"i": {
								"x": 0.833,
								"y": 0.833
							},
							"o": {
								"x": 0.167,
								"y": 0.167
							},
							"t": 40,
							"s": [
								199,
								283,
								0
							],
							"to": [
								0,
								0,
								0
							],
							"ti": [
								0,
								0,
								0
							]
						},
						{
							"i": {
								"x": 0.833,
								"y": 0.833
							},
							"o": {
								"x": 0.167,
								"y": 0.167
							},
							"t": 50,
							"s": [
								199,
								283,
								0
							],
							"to": [
								0,
								0,
								0
							],
							"ti": [
								0,
								0,
								0
							]
						},
						{
							"i": {
								"x": 0.833,
								"y": 0.833
							},
							"o": {
								"x": 0.6,
								"y": 0
							},
							"t": 60,
							"s": [
								199,
								283,
								0
							],
							"to": [
								0,
								0,
								0
							],
							"ti": [
								0,
								0,
								0
							]
						},
						{
							"t": 70,
							"s": [
								199,
								240,
								0
							]
						}
					],
					"ix": 2
				},
				"a": {
					"a": 0,
					"k": [
						200,
						240,
						0
					],
					"ix": 1
				},
				"s": {
					"a": 0,
					"k": [
						100,
						100,
						100
					],
					"ix": 6
				}
			},
			"ao": 0,
			"ip": 0,
			"op": 2700,
			"st": 0,
			"bm": 0
		},
		{
			"ddd": 0,
			"ind": 3,
			"ty": 2,
			"nm": "1",
			"refId": "image_0",
			"sr": 1,
			"ks": {
				"o": {
					"a": 0,
					"k": 100,
					"ix": 11
				},
				"r": {
					"a": 0,
					"k": 0,
					"ix": 10
				},
				"p": {
					"a": 1,
					"k": [
						{
							"i": {
								"x": 0.667,
								"y": 1
							},
							"o": {
								"x": 0.8,
								"y": 0
							},
							"t": 10,
							"s": [
								89,
								176,
								0
							],
							"to": [
								0,
								0,
								0
							],
							"ti": [
								0,
								0,
								0
							]
						},
						{
							"i": {
								"x": 0.833,
								"y": 0.833
							},
							"o": {
								"x": 0.8,
								"y": 0
							},
							"t": 20,
							"s": [
								89,
								218,
								0
							],
							"to": [
								0,
								0,
								0
							],
							"ti": [
								0,
								0,
								0
							]
						},
						{
							"i": {
								"x": 0.833,
								"y": 0.833
							},
							"o": {
								"x": 0.167,
								"y": 0.167
							},
							"t": 30,
							"s": [
								125,
								240,
								0
							],
							"to": [
								0,
								0,
								0
							],
							"ti": [
								0,
								0,
								0
							]
						},
						{
							"i": {
								"x": 0.833,
								"y": 0.833
							},
							"o": {
								"x": 0.167,
								"y": 0.167
							},
							"t": 40,
							"s": [
								125,
								240,
								0
							],
							"to": [
								0,
								0,
								0
							],
							"ti": [
								0,
								0,
								0
							]
						},
						{
							"i": {
								"x": 0.833,
								"y": 0.833
							},
							"o": {
								"x": 0.8,
								"y": 0
							},
							"t": 50,
							"s": [
								125,
								240,
								0
							],
							"to": [
								0,
								0,
								0
							],
							"ti": [
								0,
								0,
								0
							]
						},
						{
							"i": {
								"x": 1,
								"y": 1
							},
							"o": {
								"x": 0.167,
								"y": 0.167
							},
							"t": 60,
							"s": [
								89,
								218,
								0
							],
							"to": [
								0,
								0,
								0
							],
							"ti": [
								0,
								0,
								0
							]
						},
						{
							"i": {
								"x": 0.833,
								"y": 0.833
							},
							"o": {
								"x": 0.8,
								"y": 0
							},
							"t": 70,
							"s": [
								89,
								218,
								0
							],
							"to": [
								0,
								0,
								0
							],
							"ti": [
								0,
								0,
								0
							]
						},
						{
							"t": 80,
							"s": [
								89,
								176,
								0
							]
						}
					],
					"ix": 2
				},
				"a": {
					"a": 0,
					"k": [
						200,
						240,
						0
					],
					"ix": 1
				},
				"s": {
					"a": 0,
					"k": [
						100,
						100,
						100
					],
					"ix": 6
				}
			},
			"ao": 0,
			"ip": 0,
			"op": 2700,
			"st": 0,
			"bm": 0
		},
		{
			"ddd": 0,
			"ind": 4,
			"ty": 2,
			"nm": "3",
			"refId": "image_0",
			"sr": 1,
			"ks": {
				"o": {
					"a": 0,
					"k": 100,
					"ix": 11
				},
				"r": {
					"a": 0,
					"k": 0,
					"ix": 10
				},
				"p": {
					"a": 1,
					"k": [
						{
							"i": {
								"x": 0.667,
								"y": 1
							},
							"o": {
								"x": 0.8,
								"y": 0
							},
							"t": 10,
							"s": [
								312,
								176,
								0
							],
							"to": [
								0,
								0,
								0
							],
							"ti": [
								0,
								0,
								0
							]
						},
						{
							"i": {
								"x": 0.833,
								"y": 0.833
							},
							"o": {
								"x": 0.8,
								"y": 0
							},
							"t": 20,
							"s": [
								312,
								218.5,
								0
							],
							"to": [
								0,
								0,
								0
							],
							"ti": [
								0,
								0,
								0
							]
						},
						{
							"i": {
								"x": 0.833,
								"y": 0.833
							},
							"o": {
								"x": 0.167,
								"y": 0.167
							},
							"t": 30,
							"s": [
								273,
								240.5,
								0
							],
							"to": [
								0,
								0,
								0
							],
							"ti": [
								0,
								0,
								0
							]
						},
						{
							"i": {
								"x": 0.833,
								"y": 0.833
							},
							"o": {
								"x": 0.167,
								"y": 0.167
							},
							"t": 40,
							"s": [
								273,
								240.5,
								0
							],
							"to": [
								0,
								0,
								0
							],
							"ti": [
								0,
								0,
								0
							]
						},
						{
							"i": {
								"x": 0.833,
								"y": 0.833
							},
							"o": {
								"x": 0.8,
								"y": 0
							},
							"t": 50,
							"s": [
								273,
								240.5,
								0
							],
							"to": [
								0,
								0,
								0
							],
							"ti": [
								0,
								0,
								0
							]
						},
						{
							"i": {
								"x": 1,
								"y": 1
							},
							"o": {
								"x": 0.167,
								"y": 0.167
							},
							"t": 60,
							"s": [
								312,
								218.5,
								0
							],
							"to": [
								0,
								0,
								0
							],
							"ti": [
								0,
								0,
								0
							]
						},
						{
							"i": {
								"x": 0.833,
								"y": 0.833
							},
							"o": {
								"x": 0.8,
								"y": 0
							},
							"t": 70,
							"s": [
								312,
								218.5,
								0
							],
							"to": [
								0,
								0,
								0
							],
							"ti": [
								0,
								0,
								0
							]
						},
						{
							"t": 80,
							"s": [
								312,
								176,
								0
							]
						}
					],
					"ix": 2
				},
				"a": {
					"a": 0,
					"k": [
						200,
						240,
						0
					],
					"ix": 1
				},
				"s": {
					"a": 0,
					"k": [
						100,
						100,
						100
					],
					"ix": 6
				}
			},
			"ao": 0,
			"ip": 0,
			"op": 2700,
			"st": 0,
			"bm": 0
		},
		{
			"ddd": 0,
			"ind": 5,
			"ty": 2,
			"nm": "2",
			"refId": "image_0",
			"sr": 1,
			"ks": {
				"o": {
					"a": 0,
					"k": 100,
					"ix": 11
				},
				"r": {
					"a": 0,
					"k": 0,
					"ix": 10
				},
				"p": {
					"a": 1,
					"k": [
						{
							"i": {
								"x": 0.667,
								"y": 1
							},
							"o": {
								"x": 0.8,
								"y": 0
							},
							"t": 10,
							"s": [
								199,
								112,
								0
							],
							"to": [
								0,
								0,
								0
							],
							"ti": [
								0,
								0,
								0
							]
						},
						{
							"i": {
								"x": 0.833,
								"y": 0.833
							},
							"o": {
								"x": 0.8,
								"y": 0
							},
							"t": 20,
							"s": [
								199,
								155,
								0
							],
							"to": [
								0,
								0,
								0
							],
							"ti": [
								0,
								0,
								0
							]
						},
						{
							"i": {
								"x": 0.833,
								"y": 0.833
							},
							"o": {
								"x": 0.167,
								"y": 0.167
							},
							"t": 30,
							"s": [
								199,
								197,
								0
							],
							"to": [
								0,
								0,
								0
							],
							"ti": [
								0,
								0,
								0
							]
						},
						{
							"i": {
								"x": 0.833,
								"y": 0.833
							},
							"o": {
								"x": 0.167,
								"y": 0.167
							},
							"t": 40,
							"s": [
								199,
								197,
								0
							],
							"to": [
								0,
								0,
								0
							],
							"ti": [
								0,
								0,
								0
							]
						},
						{
							"i": {
								"x": 0.833,
								"y": 0.833
							},
							"o": {
								"x": 0.8,
								"y": 0
							},
							"t": 50,
							"s": [
								199,
								197,
								0
							],
							"to": [
								0,
								0,
								0
							],
							"ti": [
								0,
								0,
								0
							]
						},
						{
							"i": {
								"x": 1,
								"y": 1
							},
							"o": {
								"x": 0.167,
								"y": 0.167
							},
							"t": 60,
							"s": [
								199,
								155,
								0
							],
							"to": [
								0,
								0,
								0
							],
							"ti": [
								0,
								0,
								0
							]
						},
						{
							"i": {
								"x": 0.833,
								"y": 0.833
							},
							"o": {
								"x": 0.8,
								"y": 0
							},
							"t": 70,
							"s": [
								199,
								155,
								0
							],
							"to": [
								0,
								0,
								0
							],
							"ti": [
								0,
								0,
								0
							]
						},
						{
							"t": 80,
							"s": [
								199,
								112,
								0
							]
						}
					],
					"ix": 2
				},
				"a": {
					"a": 0,
					"k": [
						200,
						240,
						0
					],
					"ix": 1
				},
				"s": {
					"a": 0,
					"k": [
						100,
						100,
						100
					],
					"ix": 6
				}
			},
			"ao": 0,
			"ip": 0,
			"op": 2700,
			"st": 0,
			"bm": 0
		},
		{
			"ddd": 0,
			"ind": 6,
			"ty": 2,
			"nm": "6",
			"refId": "image_0",
			"sr": 1,
			"ks": {
				"o": {
					"a": 0,
					"k": 100,
					"ix": 11
				},
				"r": {
					"a": 0,
					"k": 0,
					"ix": 10
				},
				"p": {
					"a": 1,
					"k": [
						{
							"i": {
								"x": 0.667,
								"y": 0.667
							},
							"o": {
								"x": 0.167,
								"y": 0.167
							},
							"t": 10,
							"s": [
								199,
								369,
								0
							],
							"to": [
								0,
								0,
								0
							],
							"ti": [
								0,
								0,
								0
							]
						},
						{
							"i": {
								"x": 0.833,
								"y": 0.833
							},
							"o": {
								"x": 0.8,
								"y": 0.8
							},
							"t": 20,
							"s": [
								199,
								369,
								0
							],
							"to": [
								0,
								0,
								0
							],
							"ti": [
								0,
								0,
								0
							]
						},
						{
							"i": {
								"x": 0.833,
								"y": 0.833
							},
							"o": {
								"x": 0.167,
								"y": 0.167
							},
							"t": 30,
							"s": [
								199,
								369,
								0
							],
							"to": [
								0,
								0,
								0
							],
							"ti": [
								0,
								0,
								0
							]
						},
						{
							"i": {
								"x": 0.833,
								"y": 0.833
							},
							"o": {
								"x": 0.167,
								"y": 0.167
							},
							"t": 40,
							"s": [
								199,
								369,
								0
							],
							"to": [
								0,
								0,
								0
							],
							"ti": [
								0,
								0,
								0
							]
						},
						{
							"i": {
								"x": 0.833,
								"y": 0.833
							},
							"o": {
								"x": 0.167,
								"y": 0.167
							},
							"t": 50,
							"s": [
								199,
								369,
								0
							],
							"to": [
								0,
								0,
								0
							],
							"ti": [
								0,
								0,
								0
							]
						},
						{
							"i": {
								"x": 0.833,
								"y": 0.833
							},
							"o": {
								"x": 0.167,
								"y": 0.167
							},
							"t": 60,
							"s": [
								199,
								369,
								0
							],
							"to": [
								0,
								0,
								0
							],
							"ti": [
								0,
								0,
								0
							]
						},
						{
							"t": 80,
							"s": [
								199,
								369,
								0
							]
						}
					],
					"ix": 2
				},
				"a": {
					"a": 0,
					"k": [
						200,
						240,
						0
					],
					"ix": 1
				},
				"s": {
					"a": 0,
					"k": [
						100,
						100,
						100
					],
					"ix": 6
				}
			},
			"ao": 0,
			"ip": 0,
			"op": 2700,
			"st": 0,
			"bm": 0
		},
		{
			"ddd": 0,
			"ind": 7,
			"ty": 2,
			"nm": "5",
			"refId": "image_0",
			"sr": 1,
			"ks": {
				"o": {
					"a": 0,
					"k": 100,
					"ix": 11
				},
				"r": {
					"a": 0,
					"k": 0,
					"ix": 10
				},
				"p": {
					"a": 1,
					"k": [
						{
							"i": {
								"x": 0.667,
								"y": 0.667
							},
							"o": {
								"x": 0.8,
								"y": 0.8
							},
							"t": 10,
							"s": [
								89,
								304,
								0
							],
							"to": [
								0,
								0,
								0
							],
							"ti": [
								0,
								0,
								0
							]
						},
						{
							"i": {
								"x": 0.833,
								"y": 0.833
							},
							"o": {
								"x": 0.8,
								"y": 0
							},
							"t": 20,
							"s": [
								89,
								304,
								0
							],
							"to": [
								0,
								0,
								0
							],
							"ti": [
								0,
								0,
								0
							]
						},
						{
							"i": {
								"x": 0.833,
								"y": 0.833
							},
							"o": {
								"x": 0.167,
								"y": 0.167
							},
							"t": 30,
							"s": [
								125,
								326,
								0
							],
							"to": [
								0,
								0,
								0
							],
							"ti": [
								0,
								0,
								0
							]
						},
						{
							"i": {
								"x": 0.833,
								"y": 0.833
							},
							"o": {
								"x": 0.167,
								"y": 0.167
							},
							"t": 40,
							"s": [
								125,
								326,
								0
							],
							"to": [
								0,
								0,
								0
							],
							"ti": [
								0,
								0,
								0
							]
						},
						{
							"i": {
								"x": 0.833,
								"y": 0.833
							},
							"o": {
								"x": 0.8,
								"y": 0
							},
							"t": 50,
							"s": [
								125,
								326,
								0
							],
							"to": [
								0,
								0,
								0
							],
							"ti": [
								0,
								0,
								0
							]
						},
						{
							"i": {
								"x": 0.833,
								"y": 0.833
							},
							"o": {
								"x": 0.167,
								"y": 0.167
							},
							"t": 60,
							"s": [
								89,
								304,
								0
							],
							"to": [
								0,
								0,
								0
							],
							"ti": [
								0,
								0,
								0
							]
						},
						{
							"t": 80,
							"s": [
								89,
								304,
								0
							]
						}
					],
					"ix": 2
				},
				"a": {
					"a": 0,
					"k": [
						200,
						240,
						0
					],
					"ix": 1
				},
				"s": {
					"a": 0,
					"k": [
						100,
						100,
						100
					],
					"ix": 6
				}
			},
			"ao": 0,
			"ip": 0,
			"op": 2700,
			"st": 0,
			"bm": 0
		},
		{
			"ddd": 0,
			"ind": 8,
			"ty": 2,
			"nm": "7",
			"parent": 1,
			"refId": "image_0",
			"sr": 1,
			"ks": {
				"o": {
					"a": 0,
					"k": 100,
					"ix": 11
				},
				"r": {
					"a": 0,
					"k": 0,
					"ix": 10
				},
				"p": {
					"a": 1,
					"k": [
						{
							"i": {
								"x": 0.667,
								"y": 0.667
							},
							"o": {
								"x": 0.8,
								"y": 0.8
							},
							"t": 10,
							"s": [
								0,
								0,
								0
							],
							"to": [
								0,
								0,
								0
							],
							"ti": [
								0,
								0,
								0
							]
						},
						{
							"i": {
								"x": 0.833,
								"y": 0.833
							},
							"o": {
								"x": 0.8,
								"y": 0
							},
							"t": 20,
							"s": [
								0,
								0,
								0
							],
							"to": [
								0,
								0,
								0
							],
							"ti": [
								0,
								0,
								0
							]
						},
						{
							"i": {
								"x": 0.833,
								"y": 0.833
							},
							"o": {
								"x": 0.167,
								"y": 0.167
							},
							"t": 30,
							"s": [
								-39,
								22,
								0
							],
							"to": [
								0,
								0,
								0
							],
							"ti": [
								0,
								0,
								0
							]
						},
						{
							"i": {
								"x": 0.833,
								"y": 0.833
							},
							"o": {
								"x": 0.167,
								"y": 0.167
							},
							"t": 40,
							"s": [
								-39,
								22,
								0
							],
							"to": [
								0,
								0,
								0
							],
							"ti": [
								0,
								0,
								0
							]
						},
						{
							"i": {
								"x": 0.833,
								"y": 0.833
							},
							"o": {
								"x": 0.8,
								"y": 0
							},
							"t": 50,
							"s": [
								-39,
								22,
								0
							],
							"to": [
								0,
								0,
								0
							],
							"ti": [
								0,
								0,
								0
							]
						},
						{
							"i": {
								"x": 0.833,
								"y": 0.833
							},
							"o": {
								"x": 0.167,
								"y": 0.167
							},
							"t": 60,
							"s": [
								0,
								0,
								0
							],
							"to": [
								0,
								0,
								0
							],
							"ti": [
								0,
								0,
								0
							]
						},
						{
							"t": 80,
							"s": [
								0,
								0,
								0
							]
						}
					],
					"ix": 2
				},
				"a": {
					"a": 0,
					"k": [
						200,
						240,
						0
					],
					"ix": 1
				},
				"s": {
					"a": 0,
					"k": [
						100,
						100,
						100
					],
					"ix": 6
				}
			},
			"ao": 0,
			"ip": 0,
			"op": 2700,
			"st": 0,
			"bm": 0
		}
	],
	"markers": []
};


//////////////////
// WEBPACK FOOTER
// ./frontend/pages/LiveMarkets/animations/headerCubes/01_Cube_Dance_B.json
// module id = 647
// module chunks = 0